import {
  InterviewSimulationsDetailsTranslation,
  interviewSimulationsDetailsTranslation,
} from '@/assets/locales/views/interviewSimulations/details/interviewSimulationsDetails.translation.en.ts';

export type InterviewSimulationsTranslation = {
  details: InterviewSimulationsDetailsTranslation;
};

export const interviewSimulationsTranslation: InterviewSimulationsTranslation = {
  details: interviewSimulationsDetailsTranslation,
};
